// eslint-disable-next-line no-unused-vars
import {
  createStyles,
  makeStyles,
  Theme,
  withStyles,
} from '@material-ui/core/styles';
import Progress from '@material-ui/core/CircularProgress';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      height: '100%',
      width: 500,
    },
    title: {
      color: theme.palette.primary.main,
    },
  }),
);

const CircularProgress = withStyles((theme: Theme) =>
  createStyles({
    root: {
      marginLeft: theme.spacing(1),
    },
  }),
)(Progress);

export default useStyles;
export { CircularProgress };
